/**
 * PP25 capture — mirrors recently-viewed products into cart attributes so the
 * post-purchase automation (Cloudflare Worker) can read them off the order.
 *
 * Keeps its own list (up to 8 IDs) because Horizon's RecentlyViewed caps at 4
 * and we need viewed-NOT-bought candidates after excluding the purchased items.
 */
(function () {
  const KEY = 'pp25:viewed';
  const MAX = 8;
  const ATTR = '_pp_viewed';

  function getList() {
    try { return JSON.parse(localStorage.getItem(KEY) || '[]'); } catch { return []; }
  }

  function record(id) {
    if (!id) return;
    let list = getList().filter((x) => x !== String(id));
    list.unshift(String(id));
    localStorage.setItem(KEY, JSON.stringify(list.slice(0, MAX)));
  }

  // On product pages Horizon exposes the product id on the product-form input.
  const idInput = document.querySelector('input[name="product-id"], [data-product-id]');
  if (idInput) record(idInput.value || idInput.dataset.productId);

  // Sync into cart attributes (debounced, only when changed) so it rides on the order.
  function sync() {
    const list = getList();
    if (!list.length) return;
    const value = list.join(',');
    if (sessionStorage.getItem('pp25:synced') === value) return;
    fetch('/cart/update.js', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json' },
      body: JSON.stringify({ attributes: { [ATTR]: value } }),
    })
      .then((r) => { if (r.ok) sessionStorage.setItem('pp25:synced', value); })
      .catch(() => {});
  }

  // Sync on page load (covers cart/checkout entry) and when items are added to cart.
  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', sync);
  } else {
    sync();
  }
  document.addEventListener('cart:update', sync);
  document.addEventListener('product:added', sync);
})();
